import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    formControlAutoComplete: {
        margin: "10px"
    },
    formControl: {
        minWidth: "60%",
        margin: "10px",
    },
    input: {
        padding: "5px",
    },
    centerTypographyRoot: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "top"
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      },
      paddingPaper:{
        paddingBottom: theme.spacing(2),
        minHeight:"100%",
        height:"100%"
    },
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        marginTop: "10px",
      },
}), {index: 1});